import React from "react";
import QuesAns from "./QuesAns";
import "../CustomComponents/scroll.css";

function QuestionModal({ data }) {
  const auditResults = data["AuditResults"];

  return (
    // <>
    //   {auditResults === 0 && auditResults.length === 0 && (
    //     <div style={{ fontSize: "11px" }}>No Data</div>
    //   )}
    //   {auditResults !== 0 &&
    //     auditResults.length !== 0 &&
    //     auditResults.map((d, index) => <QuesAns key={index} data={d} />)}
    // </>
    <>
      {auditResults && auditResults.length === 0 ? (
        <div style={{ fontSize: "11px" }}>No Data</div>
      ) : (
        <>
          {Array.isArray(auditResults) ? (
            auditResults.map((d, index) => <QuesAns key={index} data={d} />)
          ) : (
            <QuesAns data={auditResults} />
          )}
        </>
      )}
    </>
  );
}

export default QuestionModal;
